import { render, staticRenderFns } from "./FeedbackSuc.vue?vue&type=template&id=31dff3ba&scoped=true&"
import script from "./FeedbackSuc.vue?vue&type=script&lang=js&"
export * from "./FeedbackSuc.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSuc.vue?vue&type=style&index=0&id=31dff3ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dff3ba",
  null
  
)

export default component.exports